import { type MarkGstInvoicePaidRequest } from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * API client for per-invoice GST (`/gst-invoices`): the output-GST paid flag,
 * set from the GST register. Mirrors the per-invoice TCS paid client.
 */
export const markGstInvoicePaid = async (
  invoiceId: string,
  body: MarkGstInvoicePaidRequest,
): Promise<void> => {
  await apiClient.patch(`/gst-invoices/${invoiceId}/paid`, body);
};
